import { Component, OnInit, ViewChild, SimpleChange, OnChanges, SimpleChanges } from '@angular/core';
import { SessionTimerService } from '../services/session-timer.service';
import { CountdownComponent } from 'ngx-countdown';
import { EnvService } from '../env.service';
import { SessionTimerStatus } from '../objects/Session';
import { ConfirmationService } from '../services/confirmation.service';
import { HeaderService } from '../services/header.service';
import { MainLoadingService } from '../services/main-loading.service';
import { Router } from '@angular/router';
import { Toast, BodyOutputType, ToasterService } from 'angular2-toaster';
import { Toaster } from '../objects/ToasterObject';
import { ToasterMessageService } from '../services/toaster-message.service';
import { TokenManager } from '../Globals';
import { Globals } from '../objects/Globals';
import { LoginService } from '../services/login.service';
import { BsModalService } from 'ngx-bootstrap';
import { SidePopupService } from '../services/side-popup.service';

@Component({
  selector: 'app-session-timer',
  templateUrl: './session-timer.component.html',
  styleUrls: ['./session-timer.component.css']
})
export class SessionTimerComponent implements OnInit {
  
  @ViewChild('cd') private countdown: CountdownComponent;
  @ViewChild('cycle') private cycleCountdown: CountdownComponent;
  private leftTime:number;

  config = {
    leftTime: 30, 
    format: 's', 
    demand: true,
    notify: [30]
  }

  cycleConfig = {
    leftTime: 30, 
    format: 's', 
    demand: true,
    notify: [1]
  }

  constructor(
    public globals:Globals, 
    private sessionTimerService: SessionTimerService, 
    private envService: EnvService, 
    private confirmationService: ConfirmationService, 
    private headerService: HeaderService,
    private mainLoadingService: MainLoadingService,
    private router: Router,
    private toasterMessageService: ToasterMessageService,
    private toasterService: ToasterService,
    private tokenManager:TokenManager,
    private loginService: LoginService,
    private modalService: BsModalService,
    private sidePopupService: SidePopupService) { 
    this.sessionTimerService.sessionTimerChanged$.subscribe(result => {
      switch(result){
        case SessionTimerStatus.START:
          this.resetAndBegin();
          break;
        case SessionTimerStatus.RESET:
          this.resetAndBegin();
          break;
        case SessionTimerStatus.STOP:
          this.stop();
          break;
      }
    })

    this.sessionTimerService.keepSessionAliveChanged$.subscribe(result => {
      // begin the countdown to remove
      if (result){
        this.cycleCountdown.restart();
        this.cycleCountdown.begin();
      }
      else {
        this.cycleCountdown.stop();
      }
      
    })
    this.config.leftTime = this.envService.sessionTimeout * 60;

    var leftTime = this.envService.sessionTimeout * 60;
    var keepAliveTime = Math.round((leftTime - 40) * 0.8); // 80% of left time minus 40seconds notify
    this.cycleConfig.leftTime = keepAliveTime; 
  }

  ngOnInit() {
  }

  resetAndBegin(){
    this.countdown.restart();
    this.countdown.begin();
    
  }

  // reset() {
  //   this.countdown.restart();
  //   this.countdown.begin();
  // }

  stop() {
    this.countdown.stop();
  }

  handleEvent(event){
    if (event.action == "notify"){
      this.countdown.stop();
      this.confirmationService.confirmTimeout('Session timeout', 
        'Your session is about to end. You will be automatically logged out in', 
        30, ["Log out now, CANCEL", "Stay Logged In"]).subscribe(respond => {
          if (respond.answer == "Stay Logged In"){
            this.countdown.restart();
            this.countdown.begin();
            this.headerService.keepSessionAlive().subscribe(result => {
              //console.log(result);
            })
          }
          else{
            this.logOutSession()
          }
      })
    }
  }

  handleCycleEvent(event){
    if (event.action == "notify"){
      this.countdown.stop();
      this.cycleCountdown.restart();
      this.cycleCountdown.begin();
      this.headerService.keepSessionAlive().subscribe(result => {
        //console.log(result);
      })
    }
  }

  logOutSession():void{
    this.mainLoadingService.setLoading(true);
    this.headerService.setSessionAlive(false);
    this.sessionTimerService.stopSessionTimer();
    this.headerService.endSession().subscribe(result => {
      if (result == "1"){
        this.popToast("Info", "Your session has ended", "info");
      }
      this.mainLoadingService.setLoading(false);
      this.clear();
      this.router.navigate(['/login']);
    }, error => {
      this.mainLoadingService.setLoading(false);
      this.popToast("Error", "Unable to process action", "error");
    });
  }

  popToast(title: string, body: string, type: string) {
    var toast: Toast = {
      type: type,
      title: title,
      body: body,
      showCloseButton: true,
      bodyOutputType: BodyOutputType.TrustedHtml,
      onShowCallback: (toast) => 
      {
        var toaster = new Toaster();
        toaster.id = toast.toastId;
        toaster.timestamp = Date.now();
        toaster.title = toast.title;
        toaster.content = toast.body;
        this.toasterMessageService.pushToaster(toaster);
      }
    };
    this.toasterService.pop(toast);
  }

  clear(){
    this.globals.Session = null;
    this.tokenManager.clear();
    this.toasterMessageService.clearToaster();
    this.loginService.setSession(null);
    this.hidesAllModals();
  }

  hidesAllModals(){
    if (this.confirmationService.bsModalRef){
      this.confirmationService.bsModalRef.hide();
    }
    for (let i = 1; i <= this.modalService.getModalsCount(); i++) {
      this.modalService.hide(i);
    }
    document.body.classList.remove('modal-open');
    this.sidePopupService.removePopup();
  }
}